import { render, staticRenderFns } from "./AssessmentModal.vue?vue&type=template&id=16c067d1"
import script from "./AssessmentModal.vue?vue&type=script&lang=js"
export * from "./AssessmentModal.vue?vue&type=script&lang=js"
import style0 from "./AssessmentModal.vue?vue&type=style&index=0&id=16c067d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports